import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Icon, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { signInSocialAction } from 'Store/modules/auth/actions';
import { useTranslation } from 'Hooks/useTranslation';
import { SocialProviders } from 'Types/common';

const GoogleModal = (): JSX.Element => {
  const { hideModal } = useContext(ModalContext);
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.ACCOUNT);

  const handleEmailClick = (): void => {
    hideModal();
  };

  const handleButtonGoogleClick = (): void => {
    dispatch(signInSocialAction(SocialProviders.GOOGLE));
    hideModal();
  };

  return (
    <Modals.Centered maxSize="S" onClose={handleEmailClick} hasClose>
      <FlexContainer direction="column" gap="dimension_16" align="center">
        <Icon icon="GoogleLight" />
        <Text type="headline" color="dark" size="XS_L_S" align="center">
          {t('GoogleModal.title')}
        </Text>
        <Text type="paragraphs" color="dark" size="M_L_S">
          {t('GoogleModal.subtitle')}
        </Text>
        <Text type="paragraphs" color="grey" size="XS_L_S" align="center">
          {t('GoogleModal.description')}
        </Text>
        <Buttons.Classic
          label={t('GoogleModal.email.button')}
          mode="secondary"
          size="l"
          onClick={handleEmailClick}
          fullWidth
        />
        <Buttons.Classic
          label={t('GoogleModal.button')}
          mode="primary"
          size="l"
          fullWidth
          onClick={handleButtonGoogleClick}
        />
      </FlexContainer>
    </Modals.Centered>
  );
};

export default GoogleModal;
